module.exports = __webpack_public_path__ + "img/red-cross.f9bf4ec3.svg";